export { default as default } from './Tour';
